<template>
    <div class="knowledge-asset-video">
        <b-embed
                v-if="asset.getVimeoLink()"
                type="iframe"
                aspect="16by9"
                :src="asset.getVimeoLink()"
                allowfullscreen
        />
        <div class="video-content">
            <h1
                class="text-center"
                v-if="displayTitle"
            >
                {{ asset.title }}
            </h1>

            <landing-page-event-details
                v-if="hasEvent && event && event.exists"
                class="mb-4"
                :event="event"
            />

            <div
                    v-if="asset.description"
                    class="video-description"
            >
                <p class="mb-0">
                    {{ asset.description }}
                </p>
            </div>
            <div class="video-tags">
                <tag
                        v-for="(tag, index) in asset.tags"
                        :key="index"
                >
                    {{ tag.tag }}
                </tag>
            </div>
        </div>
    </div>
</template>

<script>
    import './Video.scss';
    import Tag from "../../Tag/Tag";
    import LandingPageEventAppResource
        from "@milestoneslabs/milestones-core-js/src/AppResources/LandingPageEventAppResource";
    import LandingPageEventDetails from "../../../LandingPageEventDetails/LandingPageEventDetails";

    export default {
        name: "Video",
        components: {LandingPageEventDetails, Tag},
        props: {
            asset: {
                type: Object,
                required: true,
            },
            displayTitle: {
                type: Boolean,
                default: true,
            },
            event: {
                type: LandingPageEventAppResource,
                default: () => new LandingPageEventAppResource({}),
            },
            hasEvent: {
                type: Boolean,
                default: false,
            },
        },
    };
</script>
